/* src/app/components/case/case-details-edit/case-details-edit.component.scss */
.row {
  height: 60px;
}
.expand {
  flex: 1;
}
.case-details-custom-field-header {
  color: darkblue;
}
:host-context(.dark-theme) .case-details-custom-field-header {
  color: #88a3ff;
}
/*# sourceMappingURL=case-details-edit.component.css.map */
